import instance from "../Service";

export default class ProductBulk {
  static async listTemplates() {
    return instance.get("/product/templates");
  }

  static async createTemplate(data) {
    return instance.post("/product/templates", data);
  }

  static async createTemplateFromProduct(data) {
    return instance.post("/product/templates/from_product", data);
  }

  static async updateTemplate(templateId, data) {
    return instance.put(`/product/templates/${templateId}`, data);
  }

  static async deleteTemplate(templateId) {
    return instance.delete(`/product/templates/${templateId}`);
  }

  static downloadTemplateUrl(templateId) {
    return `${instance.defaults.baseURL}/product/templates/${templateId}/download`;
  }

  static async importPreflight(templateId, file) {
    const formData = new FormData();
    formData.append("template_id", templateId);
    formData.append("file", file);
    return instance.post("/product/import/preflight", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static async getPreflight(preflightId) {
    return instance.get(`/product/import/preflight/${preflightId}`);
  }

  static getPreflightErrorsUrl(preflightId) {
    return `${instance.defaults.baseURL}/product/import/preflight/${preflightId}/errors`;
  }

  static async executeImport(preflightId) {
    return instance.post("/product/import/execute", { preflight_id: preflightId });
  }

  static async bulkPublish(productIds) {
    return instance.post("/product/bulk/publish", { product_ids: productIds });
  }

  static async bulkIssueQr(productIds, qrType = "33", color = 0) {
    return instance.post("/product/bulk/issue_qr", {
      product_ids: productIds,
      qr_type: qrType,
      color,
    });
  }

  static async bulkDelete(productIds) {
    return instance.post("/product/bulk/delete", { product_ids: productIds });
  }

  static async exportProducts(templateId, productIds) {
    return instance.post("/product/export", {
      template_id: templateId,
      product_ids: productIds,
    });
  }

  static async listBatches() {
    return instance.get("/product/batches");
  }

  static async getActiveBatches() {
    return instance.get("/product/batches/active");
  }

  static async getBatch(batchId) {
    return instance.get(`/product/batches/${batchId}`);
  }

  static getBatchDownloadUrl(batchId) {
    return `${instance.defaults.baseURL}/product/batches/${batchId}/download`;
  }

  static async retryBatch(batchId) {
    return instance.post(`/product/batches/${batchId}/retry`);
  }
}
